import React, { useCallback } from 'react';

import { addMessage } from '@/features';
import { useAppDispatch } from '@/store';

import { TextOption } from '../ChatMessage/VisitorOptions/FieldOptions/TextOption';

import { st, classes } from './SuggestedQuestionsPayload.st.css';

export const SuggestedQuestionsPayload = ({ title }: { title?: string }) => {
  const dispatch = useAppDispatch();

  const onSubmit = useCallback(() => {
    if (title?.trim().length) {
      dispatch(addMessage({ body: { mainText: title } }));
    }
  }, [dispatch, title]);

  return (
    <TextOption
      className={st(classes.root)}
      text={title ?? ''}
      onClick={onSubmit}
    />
  );
};
